export default __webpack_public_path__ + "static/media/vimeo.e33f8f92.svg";